var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const Envelop = (_a) => {
    var { color = '#00A3FF', width = 24, height = 24, fillOpacity = '1' } = _a, props = __rest(_a, ["color", "width", "height", "fillOpacity"]);
    return (React.createElement("svg", Object.assign({ width: 100, height: 100, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("rect", { width: 100, height: 100, rx: 50, fill: color, fillOpacity: 0.06 }),
        React.createElement("path", { d: "M76.667 46v13.333c0 9.334-5.333 13.334-13.333 13.334H36.667c-8 0-13.333-4-13.333-13.334V40.667c0-9.334 5.333-13.334 13.333-13.334h18.667", stroke: color, strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "m36.666 42 8.347 6.667c2.746 2.186 7.253 2.186 10 0l3.146-2.507M70 39.333A6.667 6.667 0 1 0 70 26a6.667 6.667 0 0 0 0 13.333Z", stroke: color, strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" })));
};
export default Envelop;
